import { postToast, ToastType } from "../postToast/postToast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";

export const isApiServerError = (errorResponse: unknown) => {
	if (!errorResponse?.data.status || errorResponse?.data.status >= 500) return true;
	return false;
};

export type DisplayApiErrorToastRequest = unknown;

export const displayApiErrorToast = createAppAsyncThunk<void, DisplayApiErrorToastRequest>(
	"ui/displayApiErrorToast",
	(errorResponse, { dispatch }) => {
		const messages: string[] = [];

		/**
		 * Compute error message
		 */
		if (typeof errorResponse === "string") {
			messages.push(errorResponse);
		} else if (errorResponse?.data && !isApiServerError(errorResponse)) {
			messages.push(errorResponse?.data?.description);
		} else if (errorResponse?.code === "ERR_BAD_REQUEST") {
			messages.push(errorResponse.response.data.description);
		} else {
			messages.push("Une erreur est survenue lors de l'exécution de l'opération");
		}

		/**
		 * display error message
		 */
		if (messages.length > 0) {
			messages.forEach((msg: string) => {
				if (msg.length > 0) {
					dispatch(postToast({ type: ToastType.ERROR, message: msg }));
				}
			});
		}
	}
);
